<mat-card
  class="purchase-request-card"
  [class.purchase-request-card--linked]="hasLink"
  [class.card-focus-target]="!hasLink"
  [attr.role]="hasLink ? null : 'button'"
  [attr.tabindex]="hasLink ? null : 0"
  [attr.aria-label]="hasLink ? null : 'Abrir solicitação #' + data().id + ': ' + data().title"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  (keydown.space)="onCardSpace($event)">
  <div class="card-header">
    <div class="status-list">
      <div class="purchase-id-chip">#{{ data().id }}</div>
      @if (showBranchesCount) {
        <aionz-kanban-chip-badge
          [icon]="'business'"
          [label]="branchesCountLabel"
          [srLabel]="branchesAriaLabel"
          [compact]="true"
          [aionzTooltipComponent]="branchesTooltipComponent"
          [aionzTooltipData]="branchesTooltipData"
          aionzTooltipPosition="below"
          aionzTooltipClass="branches-tooltip"
          mode="message" />
      }
    </div>
    <div class="card-header-right">
      <div class="header-date footer-info" aionzTooltip="Data em que a solicitação foi enviada." mode="message"
        (click)="$event.stopPropagation()">
        <mat-icon>today</mat-icon>
        <span>{{ requestedAtLabel }}</span>
      </div>
      @if(hasOptions){
      <button mat-icon-button class="menu-button" [matMenuTriggerFor]="menu"
        (click)="$event.stopPropagation()">
        <mat-icon>more_vert</mat-icon>
      </button>
      }

      <mat-menu #menu="matMenu">
        @if(canChangeBuyer) {
        <button *hasCapability="UiCapability.PURCHASING_CHANGE_BUYER" mat-menu-item (click)="onChangeBuyer()">
          <mat-icon>swap_horiz</mat-icon>
          <span>Alterar comprador</span>
        </button>
        }
        @if(canCancelPurchaseRequest) {
        <button *hasCapability="UiCapability.PURCHASING_CANCEL_PURCHASE_REQUEST" mat-menu-item
          (click)="onCancelPurchaseRequest()">
          <mat-icon>cancel</mat-icon>
          <span>Cancelar solicitação</span>
        </button>
        }
        @if(canOpenAuditReport) {
        <button mat-menu-item (click)="onOpenAuditReport()">
          <mat-icon>fact_check</mat-icon>
          <span>Ver relatório de auditoria</span>
        </button>
        }
        @if(canOpenQuotationMapPdf) {
        <button mat-menu-item (click)="onOpenQuotationMapPdf()">
          <mat-icon>picture_as_pdf</mat-icon>
          <span>Baixar mapa de cotação (PDF)</span>
        </button>
        }
      </mat-menu>
    </div>
  </div>

  @if (hasLink) {
    <!-- Link real (Cmd+clique, botão do meio, copiar link); o ::after estica a área clicável pelo card. -->
    <a
      class="card-title card-title-link card-focus-target"
      [routerLink]="data().link"
      queryParamsHandling="preserve"
      [state]="linkState"
      [attr.aria-label]="'Abrir solicitação #' + data().id + ': ' + data().title"
      (click)="$event.stopPropagation()"
      >{{ data().title }}</a
    >
  } @else {
    <mat-card-title class="card-title">{{ data().title }}</mat-card-title>
  }

  @if (showDescription()) {
  <mat-card-subtitle>{{ data().description }}</mat-card-subtitle>
  }

  <div class="sections-wrapper" [class.sections-wrapper-two-columns]="showBuyerSection">
    @if (data().requesters.length > 0) {
    <div class="section-block">
      <span class="section-label">Solicitantes</span>
      <div class="requesters-row">
        @for (requester of data().requesters.slice(0, 3); track $index) {
          <seed-user-avatar
            [style]="{
              'margin-left': $index > 0 ? '-8px' : '0',
              'z-index': data().requesters.length
            }"
            [src]="requester.avatarUrl"
            [size]="24"
            [aionzTooltip]="getRequesterTooltipItem(requester)"
            mode="message" />
        }

        @if (data().requesters.length > 3) {
          <div
            class="more-requesters"
            [aionzTooltip]="getRequestersTooltipItems()"
            mode="message"
            [aionzTooltipDisabled]="getRequestersTooltipItems().length === 0">
            <mat-icon>add</mat-icon>
          </div>
        }
      </div>
    </div>
    }

    @if (showBuyerSection) {
    <div class="section-block">
      <span class="section-label">Comprador</span>
      <seed-user-avatar
        [src]="data().buyer?.avatarUrl"
        [size]="24"
        [aionzTooltip]="getBuyerTooltipItem()"
        mode="message"
        [aionzTooltipDisabled]="getBuyerTooltipItem().length === 0" />
    </div>
    }
  </div>

  <div class="card-footer">
    <mat-divider />
    <div class="footer-content">
      <div class="footer-date-texts">
        @if (showRemainingTime) {
        <div class="footer-info" [class.deadline-warning]="isDeadlineWarning" [class.deadline-over]="isDeadlineOver"
          [aionzTooltipComponent]="timePerStageComponent" [aionzTooltipData]="timePerStageTooltipData"
          aionzTooltipPosition="below" aionzTooltipClass="time-per-stage-tooltip" mode="message"
          aria-label="Tempo por etapa"
          (click)="$event.stopPropagation()">
          <mat-icon>{{ isDeadlineOver ? 'hourglass_disabled' : 'hourglass_empty' }}</mat-icon>
          <span>{{ deadlineLabel }}</span>
        </div>
        }
        @if (data().hasDuplicatedProducts) {
          @if (canUnify) {
            <a
              class="footer-info cotai-signal"
              [routerLink]="data().link"
              queryParamsHandling="preserve"
              [state]="linkState"
              [aionzTooltip]="duplicatedTooltip"
              mode="message"
              [attr.aria-label]="duplicatedTooltip"
              (click)="$event.stopPropagation()">
              <mat-icon class="cotai-gradient-text" aria-hidden="true">auto_awesome</mat-icon>
            </a>
          } @else {
            <span
              class="footer-info cotai-signal"
              tabindex="0"
              [aionzTooltip]="duplicatedTooltip"
              mode="message"
              [attr.aria-label]="duplicatedTooltip"
              (click)="$event.stopPropagation()">
              <mat-icon class="cotai-gradient-text" aria-hidden="true">auto_awesome</mat-icon>
            </span>
          }
        }
      </div>
      <div class="footer-actions">
        @if (showOrderHistoryChip) {
        <aionz-kanban-chip-badge class="order-history-chip" icon="receipt_long" [label]="''" [tooltip]="erpCodesLabel"
          [compact]="true" (click)="openOrderHistoryDialog($event)">
        </aionz-kanban-chip-badge>
        }
        @if (showTopSuppliersCount) {
          <aionz-kanban-chip-badge
            class="supplier-count-badge"
            [class.supplier-count-badge--complete]="supplierChip.complete"
            matBadge="!"
            [matBadgeHidden]="!hasPendingSuggestedSuppliers"
            matBadgeColor="warn"
            matBadgeSize="small"
            [attr.aria-label]="supplierChip.ariaLabel + (hasPendingSuggestedSuppliers ? '. Há fornecedores sugeridos pendentes de aprovação' : '')"
            [icon]="supplierChip.icon"
            [label]="supplierChip.label"
            [color]="supplierChip.color"
            [compact]="true"
            [aionzTooltipComponent]="supplierResponsesTooltipComponent"
            [aionzTooltipData]="supplierResponsesTooltipData"
            aionzTooltipPosition="below"
            aionzTooltipClass="supplier-responses-tooltip"
            mode="message" />
        }
      </div>
    </div>
  </div>
</mat-card>
